<script setup>
import { A11y, Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

defineProps({
  content: {
    type: Object,
    default: null,
  },
  type: {
    type: String,
    default: '',
  },
})

const prevButton = ref(null)
const nextButton = ref(null)
</script>

<template>
  <div class="content-block" :class="type">
    <!-- eslint-disable vue/no-v-html -->
    <div class="content-block__image">
      <swiper
        v-if="type === 'default-type'"
        class="content-block__swiper"
        :navigation="{
          nextEl: nextButton,
          prevEl: prevButton,
        }"
        :modules="[A11y, Navigation]"
        :lazy="true"
      >
        <nuxt-link
          :to="
            localePath({
              name: 'notizie-slug',
              params: { slug: content.slug },
            })
          "
        >
          <swiper-slide>
            <div class="content-block-swiper__slide__wrap">
              <div class="content-block__image">
                <SwiperPicture
                  :image="{ custom: content.portrait.responsiveImage.src }"
                  :lazy-load="true"
                />
              </div>
            </div>
          </swiper-slide>
        </nuxt-link>
      </swiper>
      <swiper
        v-else
        class="content-block__swiper"
        :navigation="{
          nextEl: nextButton,
          prevEl: prevButton,
        }"
        :modules="[A11y, Navigation]"
        :lazy="true"
      >
        <swiper-slide>
          <div class="content-block-swiper__slide__wrap">
            <div class="content-block__image">
              <SwiperPicture
                :image="{ custom: content.immagine.responsiveImage.src }"
                :lazy-load="true"
              />
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div v-if="type === 'default-type'" class="content-block__text">
      <!-- eslint-disable vue/no-v-html -->
      <div class="text-1 is-semi-bold underline-animation">
        <nuxt-link
          :to="
            localePath({
              name: 'notizie-slug',
              params: { slug: content.slug },
            })
          "
        >
          <span class="text-1" v-html="content.titolo" />
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SlideContent',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
